<template>
  <form @submit.prevent="handleSubmit">
    <input
      v-model="displayName"
      type="text"
      required
      placeholder="name"
    >
    <select
      id="grade"
      v-model="grade"
      name="grade"
      required
    >
      <option
        value=""
        disabled
        selected
        hidden
      >
        grade
      </option>
      <option value="Baby Class">
        Baby Class
      </option>
      <option value="Middle Class">
        Middle Class
      </option>
      <option value="Reception Class">
        Reception
      </option>
      <option value="Grade 1">
        1
      </option>
      <option value="Grade 2">
        2
      </option>
      <option value="Grade 3">
        3
      </option>
      <option value="Grade 4">
        4
      </option>
      <option value="Grade 5">
        5
      </option>
      <option value="Grade 6">
        6
      </option>
      <option value="Grade 7">
        7
      </option>
    </select>
    <select
      id="role"
      v-model="role"
      name="role"
      required
    >
      <option
        value=""
        disabled
        selected
        hidden
      >
        role
      </option>
      <option value="learner">
        Learner
      </option>
      <option value="teacher">
        Teacher
      </option>
    </select>
    <input
      v-model="username"
      type="text"
      required
      placeholder="username"
    >
    <input
      v-model="state.password"
      :type="showPassword ? 'text' : 'password'"
      required
      placeholder="password"
      @focus="v$.password.$touch"
    >
    <span v-if="v$.password.$error" class="error">
      {{ v$.password.$errors[0].$message }}
    </span>
    <label>
      <input
        v-model="showPassword"
        type="checkbox"
      >
      Show password
    </label>
    <div class="error">
      {{ error }}
    </div>
    <button>Create</button>
  </form>
</template>

<script>
import { reactive, ref } from 'vue'
import useCreateNew from '@/composables/useCreateNew'
import useVuelidate from '@vuelidate/core'
import { minLength } from '@vuelidate/validators'

export default {
  setup (props, context) {
    const password = ref('')
    const state = reactive({ password })
    const rules = {
      password: { minLength: minLength(6) }
    }
    const displayName = ref('')
    const email = ref('')
    const username = ref('')
    const grade = ref('')
    const role = ref('')
    const showPassword = ref(false)
    const v$ = useVuelidate(rules, state)

    // useCreateNew
    const { error, newUserCredential } = useCreateNew()

    const handleSubmit = async () => {
      if (!v$.$error) {
        await newUserCredential({ email: username.value + '@inspireschool.com', password: password.value, displayName: displayName.value, username: username.value, grade: grade.value, role: role.value })
        if (!error.value) {
          context.emit('newCredentialCreated')
          password.value = ''
          displayName.value = ''
          username.value = ''
          grade.value = ''
          role.value = ''
        }
      }
    }

    return { displayName, email, handleSubmit, error, showPassword, username, grade, role, state, v$, password }
  }
}
</script>

<style>

</style>
